<template>
    <div v-if="false">
        <slot></slot>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
  props: {
    name: { required: true, type: String },
    title: { required: false, type: String },
    sortBy: { default: null },
    dateFormat: { required: false, type: String },
    width: { required: false, type: String }
  },
  watch: { 
      	title: function(newVal) { 
          EventBus.$emit('grid-title-changed', { name: this.name, val: newVal });
        }
  }
};
</script>
